import { render, staticRenderFns } from "./draftedEmail.vue?vue&type=template&id=816736b4"
import script from "./draftedEmail.vue?vue&type=script&lang=js"
export * from "./draftedEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports